export var config = {
    serverurl: 'https://fizlink.com',
    clienturl: 'https://admin.fizlink.com',
    fizlinkurl: 'https://fizlink.com'
}